import * as React from "react";
import { AddToHomeWrapper, AddToHomeWindow, Title, Description, CallToAction, CloseButton } from "./add-to-home-style";
import { Icon } from "common/render/icon";
import type { RuntimeTheme } from "../../../lib/theme/theme";
import { withTheme } from "styled-components";
import type { AppKind, IconImage } from "common/components/SerializedApp";
import { Share, X } from "common/react-plucked";
import { getLocalizedString } from "common/components/localization";

interface Props {
    title: string;
    iconImage: IconImage;
    theme: RuntimeTheme;
    appKind: AppKind;
    onCloseTapped: () => void;
}

class AddToHome extends React.PureComponent<Props> {
    public render(): React.ReactNode {
        const { appKind } = this.props;
        return (
            <AddToHomeWrapper
                onClick={ev => {
                    if (ev.target === ev.currentTarget) this.props.onCloseTapped();
                }}>
                <AddToHomeWindow>
                    <Icon
                        clipCorners={true}
                        color={this.props.theme.primaryAccentColor}
                        image={this.props.iconImage}
                        key="Icon"
                        size={52}
                    />
                    <Title>{this.props.title}</Title>
                    <Description>{getLocalizedString("addThisAppToYourHomeScreen", appKind)}</Description>
                    <CallToAction>
                        {getLocalizedString("tapThenAddPrefix", appKind)}
                        <Share size={16} style={{ margin: "0 5px" }} />
                        {getLocalizedString("tapThenAddSuffix", appKind)}
                    </CallToAction>
                    <CloseButton onClick={this.props.onCloseTapped}>
                        <X size={12} />
                    </CloseButton>
                </AddToHomeWindow>
            </AddToHomeWrapper>
        );
    }
}

export default withTheme(AddToHome);
